<p>help-mws-settlement-reports-identity works!</p>
